import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const WeightWaistManagement = {
  label: "體重及腰圍管理",
  key: "WeightWaistManagement",
  path: "BMI/WeightWaistManagement",
  api: "TCS_V_BMIHEBMIV",
  render: (options) => <Diagram.BMI.WeightWaistManagement {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "題目",
      field: "題目",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
